import React from 'react'
import { Layout, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'

export const LegalMenu: React.FC = () => {
  return (
    <Space
      style={{ justifyContent: 'center', alignItems: 'center' }}
      wrap
      className="w-full"
      size={20}
    >
      <Link type="text" to={'/legal/cgu'}>
        Conditions générales d&apos;utilisation
      </Link>
      <Link type="text" to={'/legal/cga'}>
        Conditions générales d&apos;abonnement
      </Link>
      <Link type="text" to={'/legal/legal-notice'}>
        Mentions légales
      </Link>
      <Link type="text" to={'/legal/data-privacy-policy'}>
        Traitement des données
      </Link>
    </Space>
  )
}
